import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";
import ColoredHistogramSeries from "./ColoredHistogramSeries";

/**
 * CMF (Chaikin Money Flow) — painel próprio.
 *
 * Dois modos de exibição, porque as duas referências do indicador desenham
 * diferente: o Silverlight usa histograma COLORSTICK (default aqui) e o
 * ChartIQ desenha uma linha. `displayMode` = "histogram" | "line".
 * yAccessor(d) retorna { value, direction }.
 */
class ChaikinMoneyFlowSeries extends Component {
  constructor(props) {
    super(props);
    this.lineAccessor = this.lineAccessor.bind(this);
  }
  lineAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.value;
  }
  render() {
    const {
      yAccessor,
      displayMode,
      increasingColor,
      decreasingColor,
      stroke,
      strokeZeroLine,
      className,
      ...rest
    } = this.props;

    if (displayMode === "line") {
      return (
        <g className={className}>
          <LineSeries
            yAccessor={this.lineAccessor}
            stroke={stroke}
            fill="none"
          />
          <StraightLine yValue={0} stroke={strokeZeroLine} />
        </g>
      );
    }

    return (
      <ColoredHistogramSeries
        {...rest}
        className={className}
        yAccessor={yAccessor}
        increasingColor={increasingColor}
        decreasingColor={decreasingColor}
        strokeZeroLine={strokeZeroLine}
      />
    );
  }
}

ChaikinMoneyFlowSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  displayMode: PropTypes.string,
  increasingColor: PropTypes.string,
  decreasingColor: PropTypes.string,
  stroke: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeZeroLine: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
};

ChaikinMoneyFlowSeries.defaultProps = {
  displayMode: "histogram",
  increasingColor: "#00DD00",
  decreasingColor: "#FF0000",
  stroke: { color: "#FFFF00" },
  strokeZeroLine: { color: "#666666", dash: "Solid", width: 1, opacity: 1 },
  className: "react-stockcharts-cmf-series",
};

export default ChaikinMoneyFlowSeries;
